import React from "react";
import SideBar from "./AdminCenterSideBar";

export default function AdminCenterLayout({ children }) {
    return (
        <>
            <SideBar>
                {children}
            </SideBar>
        </>
    );
}
